import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "../firebase";
import View from "../Components/View.js";
import UserDashboard from "./UserDashboard.js";
import Sadmin from "./sadmin.js";
import Observation from "../Components/Observation.js";
import SAsummery from "../Components/superadmin/SAsummery.js";
import Viewvehicle from "../Components/security/Viewvehicle.js";
import { onAuthStateChanged, setPersistence, browserSessionPersistence } from "firebase/auth";
import DisplayObs from "../Components/DisplayObs.js";
import "../styles1/ModernAdminDashboard.css";

setPersistence(auth, browserSessionPersistence);

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("displayobs");
  const [displayName, setDisplayName] = useState("");
  const contentDisplayRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user?.email) {
        try {
          const q = query(collection(db, "users"), where("email", "==", user.email));
          const snapshot = await getDocs(q);

          if (!snapshot.empty) {
            const userData = snapshot.docs[0].data();
            setDisplayName(userData.name);
          } else {
            setDisplayName(user.email.split("@")[0]);
          }
        } catch (err) {
          console.error("Error fetching user name:", err);
          setDisplayName(user.email.split("@")[0]);
        }
      } else {
        setDisplayName("");
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  const handleMenuItemClick = (tabId) => {
    setActiveTab(tabId);
    requestAnimationFrame(() => {
      contentDisplayRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  const renderContent = () => {
    switch (activeTab) {
      case "sadmin":
        return <Sadmin />;
      case "view":
        return <View />;
      case "user":
        return <UserDashboard />;
      case "observation":
        return <Observation />;
      case "sasummary":
        return <SAsummery />;
      case "viewvehicle":
        return <Viewvehicle />;
      case "displayobs":
        return <DisplayObs />;
      default:
        return <DisplayObs />;
    }
  };

  // SVG Icon Components
  const EyeIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );

  const ChartIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <path d="M8 16V12M12 16V8M16 16V10"/>
    </svg>
  );

  const CarIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
    </svg>
  );

  const ShieldIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );

  const ClipboardIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
      <rect x="8" y="2" width="8" height="4" rx="1"/>
      <line x1="9" y1="12" x2="15" y2="12"/>
      <line x1="9" y1="16" x2="15" y2="16"/>
    </svg>
  );

  const QRIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM13 13h2v2h-2v-2zM15 15h2v2h-2v-2zM13 17h2v2h-2v-2zM15 19h2v2h-2v-2zM17 13h2v2h-2v-2zM19 15h2v2h-2v-2zM17 17h2v2h-2v-2zM19 19h2v2h-2v-2z"/>
    </svg>
  );

  const menuItems = [
    { id: "view", label: "Latest Reviews", icon: <EyeIcon /> },
    { id: "sasummary", label: "Reviews Sum", icon: <ChartIcon /> },
    { id: "viewvehicle", label: "Vehicle", icon: <CarIcon /> },
    { id: "sadmin", label: "Admin", icon: <ShieldIcon /> },
    { id: "observation", label: "Observations", icon: <ClipboardIcon /> },
    { id: "user", label: "Scan QR", icon: <QRIcon /> },
  ];

  return (
    <div className="modern-dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <div className="user-info">
          <div className="user-avatar">
            👤 
          </div>
          <div className="user-details">
            <h2 className="user-greeting">Hi {displayName || "Guest"}!</h2>
            <p className="user-role">Admin Panel</p>
          </div>
        </div>
        <div className="header-icons">
          <div className="icon-circle">
            ✉️
          </div>
          <div className="icon-circle">
            🔔
          </div>
        </div>
      </div>

      {/* Balance Card */}
      <div className="balance-card">
        <div className="card-circle card-circle-top"></div>
        <div className="card-circle card-circle-bottom"></div>

        <div className="card-content">
          <div className="card-header-row">
            <p className="card-subtitle">Dashboard Overview</p>
            <div className="card-arrow-btn">
              →
            </div>
          </div>

          <h1 className="card-title">Active Sessions</h1>

          <p className="card-description">
            Security - Access Control System
          </p>

          <div className="card-status">
            <span>Status: Active</span>
            <span className="status-icon">📋</span>
          </div>
        </div>
      </div>

      {/* Menu Grid */}
      <div className="menu-grid">
        {menuItems.map((item) => {
          const isActive = activeTab === item.id;
          
          return (
            <div
              key={item.id}
              onClick={() => handleMenuItemClick(item.id)}
              className={`menu-item ${isActive ? 'menu-item-active' : ''}`}
            >
              <div className={`menu-icon ${isActive ? 'menu-icon-active' : ''}`}>
                {item.icon}
              </div>
              <span className={`menu-label ${isActive ? 'menu-label-active' : ''}`}>
                {item.label}
              </span>
            </div>
          );
        })}
      </div>

      {/* Quick Actions */}
      <div className="quick-actions-section">
        <h3 className="section-title">Quick Actions</h3>
        
        <div
          onClick={() => window.open("https://dmcvisite.pages.dev/", "_blank")}
          className="action-card"
        >
          <div className="action-card-content">
            <div className="action-icon action-icon-primary">
              🔗
            </div>
            <div className="action-text">
              <p className="action-title">DMC Visit</p>
              <p className="action-subtitle">Access external portal</p>
            </div>
          </div>
          <span className="action-arrow action-arrow-primary">→</span>
        </div>

         {/* Driver Dashboard (New) */}
       <div
          onClick={() => navigate("/admin/driverdash")}
          className="action-card"
        >
          <div className="action-card-content">
            <div className="action-icon action-icon-success">🚗</div>
            <div className="action-text">
              <p className="action-title">Driver</p>
              <p className="action-subtitle">Open Driver Dashboard</p>
            </div>
          </div>
          <span className="action-arrow action-arrow-primary">→</span>
        </div>

        <div
          onClick={handleLogout}
          className="action-card"
        >
          <div className="action-card-content">
            <div className="action-icon action-icon-danger">
              🚪
            </div>
            <div className="action-text">
              <p className="action-title">Logout</p>
              <p className="action-subtitle">Sign out from your account</p>
            </div>
          </div>
          <span className="action-arrow action-arrow-danger">→</span>
        </div>
      </div>

      {/* Active Tab Content Display */}
      <div className="content-display" ref={contentDisplayRef}>
        {renderContent()}
      </div>
    </div>
  );
};

export default AdminDashboard;
